import request from '@/utils/request'

// 机构主体信息（仅机构管理员）
export function companyInfo() {
  return request.post('/company/info')
}

// 修改机构信息：POST name short_name contact phone city address
export function companyUpdate(data) {
  return request.post('/company/update', data)
}
